import React from 'react';
import { Button } from 'react-bootstrap';
import Icon from 'components/DesignSystem/Icon';

import Slider from 'components/DesignSystem/Slider';
import useSliderProps from 'hooks/Meteorology/Weather/SeasonalForecast/useSliderProps';
import useSelectionPeriods from 'hooks/Meteorology/Weather/SeasonalForecast/useSelectionPeriods';
import { cssVar } from 'constants/theme';

import './index.scss';

export default function PeriodSlider() {
  const {
    periodOffset,
    setPeriodOffset,
    formattedPeriod,
    isDisabled,
  } = useSelectionPeriods();

  const {
    sliderMax,
    sliderMin,
    sliderOnChange,
  } = useSliderProps();

  return (
    <div className={`seasonal-forecast-period-control ${isDisabled ? 'disabled' : ''}`}>
      <Button variant="link" onClick={() => setPeriodOffset(sliderMin)}>
        <div className="seasonal-forecast-slider-control-button">
          <Icon iconType="double_left_arrow" color={cssVar('text-disabled')} />
        </div>
      </Button>
      <Button variant="link" onClick={() => setPeriodOffset(Math.max(periodOffset - 1, sliderMin))}>
        <div className="seasonal-forecast-slider-control-button">
          <Icon iconType="left_arrow" color={cssVar('text-disabled')} />
        </div>
      </Button>
      <Slider
        max={sliderMax}
        min={sliderMin}
        value={periodOffset}
        setValue={sliderOnChange}
        renderOnThumb={() => formattedPeriod || ''}
        className="seasonal-forecast-slider"
      />
      <Button variant="link" onClick={() => setPeriodOffset(Math.min(periodOffset + 1, sliderMax))}>
        <div className="seasonal-forecast-slider-control-button">
          <Icon iconType="right_arrow" color={cssVar('text-disabled')} />
        </div>
      </Button>
      <Button variant="link" onClick={() => setPeriodOffset(sliderMax)}>
        <div className="seasonal-forecast-slider-control-button">
          <Icon iconType="double_right_arrow" color={cssVar('text-disabled')} />
        </div>
      </Button>
    </div>
  );
}
